import * as React from 'react';
import { OverrideExperiment } from './types';

export const OverrideExperimentContext = React.createContext<OverrideExperiment>({});
OverrideExperimentContext.displayName = 'OverrideExperimentContext';
